import { Injectable } from '@angular/core';
import { XmppService } from "./xmpp.service";
import { DataService } from "./data.service";
import { UserManagementService } from 'app/services/user-management.service';
import { LogService } from 'app/services/log.service';

@Injectable()
export class ChatService {

    isChatConnected = false;

    chat_history = [];
    current_user_id = null;

    total_unread = false;

    chat_notifications = [];

    selected_chat_room = "";

    constructor(
        private xmppService: XmppService,
        private dataService: DataService,
        private user_service: UserManagementService,
        private logService: LogService,
    ) {
        this.xmppService.message_received_notifier = (unread_details) => {

            if(
                this.selected_chat_room === unread_details["group_jid"]
            ) {
                this.saveChatHistory(unread_details);
            }

            const details = unread_details["group_jid"].split('_');
            const project_id = +details[0];
            const other_user = (+details[1] === this.dataService.currentUser['id']) ? +details[2] : +details[1];
            const unread_count = this.get_unread_count(other_user, project_id);
            let found_msg = false;
            for (var i = 0; i < this.chat_notifications.length; i++) {
                if (unread_details["group_jid"] === this.chat_notifications[i]["group_id"]) {

                    this.chat_notifications[i]["unread_count"] = unread_count;
                    found_msg = true;
                    break;
                }
            }
            if(!found_msg) {
                this.chat_notifications.push({
                    "group_id": unread_details["group_jid"],
                    "project_id": project_id,
                    "user_id": other_user,
                    "unread_count": unread_count
                });
            }

            this.update_notifier();
        };
    }

    update_notifier() {
        this.total_unread = false;
        for (let i = 0; i < this.chat_notifications.length; i++) {
            if (this.chat_notifications[i]["unread_count"] > 0) {
                this.total_unread = true;
                break;
            }
        }
        this.logService.printLog("Chat notifications - " + this.chat_notifications);
    }


    go_online() {
        this.current_user_id = JSON.parse(localStorage.getItem('currentUser'))["id"];

        this.getChatHistory();

        if (!this.isChatConnected) {

            if(localStorage.getItem('currentUser')){

                this.isChatConnected = true;

                this.xmppService.username = JSON.parse(localStorage.getItem('currentUser'))["id"];
                this.xmppService.password = JSON.parse(localStorage.getItem('currentUser'))["token"];

                if (this.xmppService.username !== "" && this.xmppService.password !== "") {

                    // To have multiple sessions at one time
                    this.xmppService.connectToXmpp(
                        function (isOnline) {
                            this.createRoomsList();
                        }.bind(this)
                    );
                }
            } else {
                this.logService.printLog("No user details provided for chatting");
            }
        } else {
            this.isChatConnected = false;
            this.xmppService.disconnectFromXMPP();
        }
    }

    createRoomsList() {
        const userId = this.dataService.currentUser['id'];

        for (let i = 0; i < this.dataService.project_list.length; i++) {
            const project = this.dataService.project_list[i];
            const userTypes = ['owner', 'patent_engineer', 'researcher', 'reviewer', 'technical_expert', 'legal_counsel'];

            let roomName = "";
            for (let j = 0; j < userTypes.length; j++) {

                const userType = userTypes[j];

                var project_users = [];

                if (userType === 'owner') {
                    project_users = [project[userType]];
                } else {
                    project_users = project[userType];
                }

                for (let k = 0; k < project_users.length; k++) {
                    const projectUsers = project_users[k];
                    roomName = project["fip_id"] + "_";
                    const projectUserId = projectUsers["id"];

                    if (projectUserId > userId) {
                        roomName += userId + "_" + projectUserId;
                    } else if (projectUserId < userId) {
                        roomName += projectUserId + "_" + userId;
                    } else {
                        roomName = "";
                    }

                    if (!this.xmppService.one2OneRooms.includes(roomName) && roomName !== "") {
                        this.xmppService.one2OneRooms.push(roomName);
                    }
                }
            }
        }

        this.logService.printLog("XMPP Room list count: " + this.xmppService.one2OneRooms.length)
        if (this.isChatConnected) {
            this.xmppService.joinAllOne2OneRooms();
        }
    }

    getChatHistory() {
        this.user_service.getChatHistory(this.current_user_id,
            (response) => {
                if(response.status) {
                    this.chat_history = response.data;
                    this.logService.printLog(JSON.stringify(this.chat_history))
                } else {
                    this.logService.printLog("Could not fetch chat history.");
                }
            });
    }

    saveChatHistory(history_data) {
        let found = false;

        for (let i = 0; i < this.chat_history.length; i++) {
            if (this.chat_history[i]['group_jid'] === history_data['group_jid']) {
                found = true;
                this.chat_history[i]['read_count'] = history_data['read_count'];
            }
        }

        if (!found) {
            this.chat_history.push(history_data);
        }

        this.user_service.saveChatHistory(history_data, this.current_user_id, (response) => {
            if(response.status) {
                this.logService.printLog("Chat history saved");
            } else {
                this.logService.printLog("Could not save chat history.");
            }
        });
    }

    get_chat_room_name(user_id, project_id = this.dataService.selected_project) {

        let roomName = project_id + "_";

        const current_user = this.dataService.currentUser['id'];

        if (current_user > user_id) {
            roomName += user_id + "_" + current_user;
        } else if (current_user < user_id) {
            roomName += current_user + "_" + user_id;
        } else {
            roomName = "";
        }


        return roomName;
    }

    get_unread_count(user_id, project_id = this.dataService.selected_project){
        const chat_room = this.get_chat_room_name(user_id, project_id);
        let unread = 0;

        if(this.xmppService.groupMessages){
            if(this.xmppService.groupMessages[chat_room]){
                unread = this.xmppService.groupMessages[chat_room].length;
            }
        }

        for (let i = 0; i < this.chat_history.length; i++) {
            if (this.chat_history[i]['group_jid'] === chat_room) {
                unread -= this.chat_history[i]['read_count']
            }
        }

        return unread < 0 ? 0:unread;
    }
}

